import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Button, Card, CardContent, CircularProgress, Container, CssBaseline, FormControl, FormControlLabel, FormLabel, Grid, IconButton, Link as LinkA, ListItemIcon, Menu, MenuItem, Pagination, Radio, RadioGroup, TextField, ToggleButton, ToggleButtonGroup, Typography, Tooltip } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { withStyles } from "@mui/styles";
import clsx from 'clsx';
import { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import HeaderMenu from "src/components/header-menu";
import { Styles } from "src/styles/material-styles";
import Api from "src/services/api";
import moment, { now } from "moment";
import * as calledsActions from '../../redux/actions/calleds';
import * as headerMenuActions from '../../redux/actions/header-menu';
import * as userSessionActions from '../../redux/actions/user-session';
import * as lastCalledsQueueActions from '../../redux/actions/last-calleds-queue'
import { AbilityContext } from '../../config/ability-context'
import { Overlay } from "src/styles/global";
import CustomizedSnackbars from "src/components/material-snackbars";
import { PapiroConsole } from "src/utils/papiroConsole";
import FirstElement from "src/components/first-element";
import { Add, CallMade, Email, ExitToApp, MoreVert, QueuePlayNext } from "@mui/icons-material";
import Footer from "src/components/footer";
import { searchById, getOrganizationsDapper } from "src/services/called.service";
import * as OrganizationFieldService from 'src/services/organizationfield.service';
import * as OrganizationFieldOptionsService from 'src/services/organizationfieldoptionsvalues.service';
import SimpleDatePicker from 'src/components/date-pickers/inline-no-today';
import SimpleAutoComplete from 'src/components/auto-complete/autocomplete-dialog-with-z-index';
import CalledCard from "../general-search/components/calleds-card";
import TreeDots from 'src/components/tree-dots';
import VideoCallIcon from '@mui/icons-material/VideoCall';
import { Link, useLocation } from 'react-router-dom';
import fileDownload from "js-file-download";
import ApiReports from "src/services/apireport";
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import '../called-list/style.css';

class CalledsArchived extends Component {
    constructor(props) {

        super(props)

        const { userSession, intl } = this.props

        if (userSession == null || userSession.user == null || userSession.user.userrole == null) {
            Api.logoff();
        }

        this.userOrganizations = userSession.user.userorganizations;

        this.isClient = true
        this.isAdm = false
        this.isTechnical = false
        this.admGlobal = false
        this.isAdmOrg = false
        this.isCoordenator = false

        userSession.user.userrole.map((item, key) => {
            if (item.role.roletype != 3) {
                this.isClient = false;
            }
            if (item.role.roletype == 2) {
                this.isTechnical = true;
            }
            if (item.role.roletype == 0 || item.role.roletype == 1 || item.role.roletype == 4) {
                this.isAdm = true;
            }
            if (item.role.roletype == 1)
                this.isAdmOrg = true;
            if (item.role.roletype == 4)
                this.isCoordenator = true;
            if (item.role.roletype == 0) {
                this.admGlobal = true;
            }
        })

        let filters = [
            { name: intl.formatMessage({ id: "id" }), id: "id" },
            { name: intl.formatMessage({ id: "title" }), id: "title" },
            { name: intl.formatMessage({ id: "requestuser" }), id: "requestuser" },
            //{ name: intl.formatMessage({ id: "assigned" }), id: "assigneduser" },
        ]

        if (!this.isClient) {
            filters.push(
                { name: 'E-mail do solicitante', id: "requestusermail" },
                { name: intl.formatMessage({ id: "request.user.document" }), id: "requestuserdocument" },
            )
        }

        this.orderFieldList = [
            {
                name: "id",
                displayName: "ID",
            },
            {
                name: "openingdate",
                displayName: intl.formatMessage({ id: "creation.date" }),
            },
            {
                name: "duedate",
                displayName: intl.formatMessage({ id: "estimated.solution.date" }),
            }
        ]

        this.canStartCallCenter = false;
        userSession.user.organizationusers.map((item) => {
            if (item.organization.organizationsettings) {
                if (item.organization.organizationsettings.allowscreateanonymouscalledsbyemail) {
                    this.isCheckEmail = true;
                }
                if (item.organization.organizationsettings.canstartcallcenter) {
                    this.canStartCallCenter = true;
                }
            }
        });

        if (this.admGlobal == true && this.isClient == false) {
            this.isCheckEmail = true;
            this.canStartCallCenter = true;
        }
        const now = new Date()

        this.state = {
            calleds: [],
            count: 0,
            totalPages: 0,
            page: 1,
            pageStart: 0,
            pageEnd: 0,
            searchValue: '',
            filterSelected: 0,
            filters: filters,
            orderFields: this.orderFieldList,
            dateStart: new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000),
            dateEnd: now,
            dateOptions: [
                { id: 1, name: 'Data de abertura' },
                { id: 2, name: 'Data da solução' }
            ],
            dateOptionSelected: { id: 1, name: 'Data de abertura' },
            contentFilter: '',
            contentOrder: '',

            loading: false,
            hasSearched: false,
            lastOrgFieldParams: null,
            openNotification: false,
            notificationVariant: "error",
            notificationMessage: "",

            itemsTree: [],
            filterMenuAnchorEl: null,
            checkMailAndVideoCallInsert: false,
            openFilterDrawer: true,
            drawerAnimationClass: '',
            drawerGridAnimationClass: '',
            valueSpacingGrid: 9,
            drawerFilterId: '',
            drawerFilterTitle: '',
            drawerFilterRequestUser: '',
            drawerFilterEmail: '',
            drawerFilterDocument: '',

            // ── Campos personalizados ─────────────────────────────────────────
            orgFieldActive: false,
            orgFieldSearchMode: 'text_number',
            orgFieldOrganization: null,
            orgFieldOrganizationOptions: [],
            orgFieldOrganizationLoading: false,
            orgField: null,
            orgFieldOptions: [],
            orgFieldOptionsLoading: false,
            orgFieldOptionValue: null,
            orgFieldOptionValues: [],
            orgFieldOptionValuesLoading: false,
            orgFieldDateValue: null,
            orgFieldCheckboxValue: null,
            orgFieldSearchText: '',
            orgFieldCalleds: [],
            orgFieldCount: 0,
            orgFieldPage: 1,
            orgFieldTotalPages: 0,
            orgFieldPageStart: 0,
            orgFieldPageEnd: 0,
        }

        this.orderTwoActions = [
            "id", "title", "open", "duedate"
        ]

        this.handleChangeFieldValue = this.handleChangeFieldValue.bind(this)
        this.handleChangeValue = this.handleChangeValue.bind(this)
        this.addFilter = this.addFilter.bind(this)
        this.clearFields = this.clearFields.bind(this)
        this.clearFilters = this.clearFilters.bind(this)
        this.callSearch = this.callSearch.bind(this)
        this.closeNotification = this.closeNotification.bind(this)
        this.setPagination = this.setPagination.bind(this)
        this.goToCalled = this.goToCalled.bind(this)
        this.openCanAssignCalledDialog = this.openCanAssignCalledDialog.bind(this)
        this.consultCalled = this.consultCalled.bind(this)
        this.setNotification = this.setNotification.bind(this)
        this.setLoading = this.setLoading.bind(this)
        this.handleClickFilterMenu = this.handleClickFilterMenu.bind(this)
        this.handleCloseFilterMenu = this.handleCloseFilterMenu.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
    }

    handleClickFilterMenu = (event) => {
        this.setState({ filterMenuAnchorEl: event.currentTarget })
    }

    handleCloseFilterMenu = _ => {
        this.setState({ filterMenuAnchorEl: null })
    }

    toggleFilterDrawer = () => {
        if (this.state.openFilterDrawer) {
            this.setState({ drawerAnimationClass: 'filter-drawer-exit' }, () => {
                setTimeout(() => {
                    this.setState({ openFilterDrawer: false, drawerAnimationClass: '' });
                }, 500);
            });
            setTimeout(() => { this.setState({ valueSpacingGrid: 10 }); }, 100);
            setTimeout(() => { this.setState({ valueSpacingGrid: 11 }); }, 200);
            setTimeout(() => { this.setState({ valueSpacingGrid: 12 }); }, 300);
        } else {
            this.setState({ openFilterDrawer: true, drawerAnimationClass: 'filter-drawer-enter', drawerGridAnimationClass: 'filter-grid-drawer-enter' }, () => {
                setTimeout(() => {
                    this.setState({ drawerAnimationClass: '', drawerGridAnimationClass: '' });
                }, 500);
            });
            setTimeout(() => { this.setState({ valueSpacingGrid: 11 }); }, 100);
            setTimeout(() => { this.setState({ valueSpacingGrid: 10 }); }, 200);
            setTimeout(() => { this.setState({ valueSpacingGrid: 9 }); }, 300);
        }
    }

    async componentDidMount() {
        const { intl, userSession } = this.props

        var userId = userSession && userSession.user && userSession.user.id
        if (this.props.location && this.props.location.state && this.props.location.state.origin) {

            this.getFiltersByFlagDisplayFilterInCalledListNew()
        } else {
            let sessionPage = localStorage.getItem('calledsPageArchivedCalleds')
            if (sessionPage == null) {
                sessionPage = 1
                localStorage.setItem('calledsPageArchivedCalleds', '1')
            }
            if (!isNaN(sessionPage) && typeof sessionPage === 'string')
                sessionPage = parseInt(sessionPage)

            await this.addFilterOnComponentDidMount(intl)
            this.setState({ page: sessionPage })

            if (this.canStartCallCenter && !this.isClient && !this.state.checkMailAndVideoCallInsert) {
                var itemCallCenter =
                    <Button
                        color="secondary"
                        size="large"
                        style={{ marginBottom: "5px" }}
                        onClick={this.videoCallClick}
                        startIcon={<VideoCallIcon />}
                        disabled={this.state.disabledvertex}
                    >
                        {intl.formatMessage({ id: "video.call" })}
                    </Button>
                if (this.state.itemsTree && !this.state.itemsTree.includes(itemCallCenter)) {
                    this.state.itemsTree.push(itemCallCenter);
                }
            }
            if (this.isCheckEmail && !this.isClient && !this.state.checkMailAndVideoCallInsert) {
                var itemEmail =
                    <Button
                        color="secondary"
                        size="large"
                        style={{ marginBottom: "5px" }}
                        onClick={this.openCheckEmail}
                        startIcon={<Email />}
                    >
                        {intl.formatMessage({ id: "check.email" })}
                    </Button>
                if (this.state.itemsTree && !this.state.itemsTree.includes(itemEmail)) {
                    this.state.itemsTree.push(itemEmail);
                }
            }
            this.setState({ checkMailAndVideoCallInsert: true })
        }
    }

    addFilterOnComponentDidMount = async (intl) => {

        let newFilter = localStorage.getItem('newFilterArchivedCalleds')
        let newSearch = localStorage.getItem('newSearchArchivedCalleds')

        if (newFilter != null && newFilter.length > 0 && newSearch != null && newSearch.length > 0) {

            await this.setState({ contentFilter: '' })
            var field = newFilter.split('|')
            var value = newSearch.split('|')
            if (field && field.length > 0 && value && value.length > 0) {
                for (let i = 0; i < field.length; i++) {
                    if (field[i].length > 0) {
                        let nameField = field[i]
                        let filterName = this.state.filters.filter(f => f.id === field[i])
                        if (filterName && filterName.length > 0)
                            nameField = filterName[0].name

                        if (nameField == "calledcards") {
                            nameField = intl.formatMessage({ id: "called.report.header" })
                        }
                        var contentFilterTest = '' + nameField + " = " + value[i] + "\n"
                        if (!(this.state.contentFilter.includes(contentFilterTest))) {
                            await this.setState({
                                contentFilter: this.state.contentFilter + nameField + " = " + value[i] + "\n"
                            });
                        }

                    }
                }
            }
        }
        let calledListPersistFilter = localStorage.getItem('calledListPersistFilterArchivedCalleds')
        if (calledListPersistFilter && calledListPersistFilter == 'true') {
            localStorage.setItem('calledListPersistFilterArchivedCalleds', '');
        }
        // else if ((newOrderFilter != null && newOrderSearch != null && newOrderFilter.length == 0 && newOrderSearch.length == 0) && (newFilter != null && newSearch != null && newFilter.length == 0 && newSearch.length == 0)) {
        //     await this.getDefaultFilter()
        // }
    }

    handleChangeFieldValue = (value) => {
        const { intl } = this.props

        let returnAction = [{ id: 1, name: intl.formatMessage({ id: "search" }) }]
        let twoActions = this.orderTwoActions.find(e => e === value)
        if (twoActions && twoActions.length > 0) {
            returnAction = [
                { id: 1, name: intl.formatMessage({ id: "search" }) },
                { id: 2, name: intl.formatMessage({ id: "order" }) }
            ]
        }
        return returnAction
    }

    // ── Campos personalizados ─────────────────────────────────────────────────

    getOrgFieldType = (field) => field?.organizationfieldtype ?? field?.organizationFieldType ?? null

    loadOrgFieldOrganizations = async () => {
        if (this.state.orgFieldOrganizationOptions.length > 0 || this.state.orgFieldOrganizationLoading) return
        this.setState({ orgFieldOrganizationLoading: true })
        try {
            const result = await getOrganizationsDapper()
            if (result && result.success) {
                const data = (result.data || []).sort((a, b) => (a.name || '').localeCompare(b.name || ''))
                this.setState({ orgFieldOrganizationOptions: data })
            }
        } catch (e) { PapiroConsole.log(e) }
        this.setState({ orgFieldOrganizationLoading: false })
    }

    loadOrgFieldFields = async (organizationId) => {
        this.setState({ orgFieldOptionsLoading: true, orgField: null, orgFieldOptionValues: [], orgFieldOptionValue: null, orgFieldOptions: [] })
        try {
            const result = organizationId
                ? await OrganizationFieldService.getAllActiveByOrganizationIdWithoutIncludes(organizationId)
                : await OrganizationFieldService.getAllActivedWithoutIncludes()
            if (result && result.success) this.setState({ orgFieldOptions: result.data || [] })
        } catch (e) { PapiroConsole.log(e) }
        this.setState({ orgFieldOptionsLoading: false })
    }

    loadOrgFieldOptionValues = async (fieldId) => {
        this.setState({ orgFieldOptionValuesLoading: true, orgFieldOptionValue: null, orgFieldOptionValues: [] })
        try {
            const result = await OrganizationFieldOptionsService.getAllByOrganizationFieldIdWithoutIncludes(fieldId)
            if (result && result.success) this.setState({ orgFieldOptionValues: result.data || [] })
        } catch (e) { PapiroConsole.log(e) }
        this.setState({ orgFieldOptionValuesLoading: false })
    }

    handleOrgFieldOrganizationChange = (_, org) => {
        this.setState({ orgFieldOrganization: org, orgField: null, orgFieldOptionValues: [], orgFieldOptionValue: null, orgFieldOptions: [] })
        if (org) this.loadOrgFieldFields(org.id)
    }

    handleOrgFieldFieldChange = (_, field) => {
        this.setState({ orgField: field, orgFieldOptionValue: null, orgFieldOptionValues: [], orgFieldDateValue: null, orgFieldCheckboxValue: null })
        const type = this.getOrgFieldType(field)
        if (field && [2, 4, 6].includes(type)) this.loadOrgFieldOptionValues(field.id)
    }

    getCalledsByOrganizationField = async (page = 1) => {
        const { intl } = this.props
        const { orgFieldSearchMode, orgFieldOrganization, orgField, orgFieldOptionValue,
                orgFieldDateValue, orgFieldCheckboxValue, orgFieldSearchText, dateStart, dateEnd } = this.state

        if (orgFieldSearchMode === 'text_number' && !orgFieldSearchText) {
            this.setNotification("error", intl.formatMessage({ id: "value.to.search" }))
            return
        }
        if (orgFieldSearchMode === 'specific' && !orgField) {
            this.setNotification("error", intl.formatMessage({ id: "general.search.org.field.field.required" }))
            return
        }

        this.setState({ loading: true })

        let formdata = new FormData()
        if (dateStart) formdata.append('startdate', dateStart.toISOString())
        if (dateEnd) formdata.append('enddate', dateEnd.toISOString())
        formdata.append('SearchAllTextAndNumber', orgFieldSearchMode === 'text_number')
        formdata.append('Archived', true)

        if (orgFieldSearchMode === 'specific') {
            if (orgFieldOrganization) formdata.append('OrganizationId', orgFieldOrganization.id)
            formdata.append('OrganizationFieldId', orgField.id)
            const fieldType = this.getOrgFieldType(orgField)
            if ([2, 4, 6].includes(fieldType) && orgFieldOptionValue)
                formdata.append('OrganizationFieldOptionsValuesId', orgFieldOptionValue.id)
            else if (fieldType === 3 && orgFieldCheckboxValue != null)
                formdata.append('FieldValue', orgFieldCheckboxValue)
            else if (fieldType === 9 && orgFieldDateValue)
                formdata.append('FieldValue', moment(orgFieldDateValue).format('YYYY-MM-DD'))
        }

        const config = { headers: { "Content-Type": "multipart/form-data" } }
        const url = `calleds/general-search-organization-field?searchText=${encodeURIComponent(orgFieldSearchText)}&page=${page}`

        try {
            const result = await Api.post(url, formdata, config)
            if (result.data.success) {
                const count = result.data.count
                const pagination = this.setPagination(count, page, 10)
                this.setState({
                    orgFieldCalleds: result.data.data || [],
                    orgFieldCount: count,
                    orgFieldPage: pagination.page,
                    orgFieldTotalPages: pagination.totalPages,
                    orgFieldPageStart: pagination.pageStart,
                    orgFieldPageEnd: pagination.pageEnd,
                    orgFieldActive: true,
                })
            } else {
                this.setNotification("error", result.data.errors?.[0] ?? intl.formatMessage({ id: "process.error" }))
            }
        } catch (e) {
            this.setNotification("error", intl.formatMessage({ id: "process.error" }))
        }
        this.setState({ loading: false })
    }

    // ─────────────────────────────────────────────────────────────────────────

    handleChangeValue = (name, value) => {
        this.setState(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    addFilter = async (filter, value) => {
        const intl = this.props.intl

        if (value.trim() == '' && filter == 0) {
            this.setState({
                openNotification: true, notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "caled.list.notification.select.one.filter.option" })
            });
        } else {
            let newFilter = localStorage.getItem('newFilterArchivedCalleds')
            let newSearch = localStorage.getItem('newSearchArchivedCalleds')

            if (value != '' && filter != 0) {
                if (filter === "open") {
                    let date = value.split("/");
                    if (date.length === 3) {
                        date = `${date[2]}-${date[1]}-${date[0]}`
                    }
                    newFilter += filter + "|";
                    newSearch += date + "|";

                    let nameField;
                    for (let i = 0; i < this.state.filters.length; i++) {

                        if (this.state.filters[i].id === filter) {
                            nameField = this.state.filters[i].name;
                        }
                    }

                    this.setState({
                        contentFilter: `${this.state.contentFilter}${nameField} = ${value}\n`
                    })

                } else {
                    if (newFilter == null) {
                        newFilter = ''
                    }
                    if (newSearch == null) {
                        newSearch = ''
                    }
                    newFilter += filter + "|"
                    newSearch += value + "|"

                    let nameField;
                    for (let i = 0; i < this.state.filters.length; i++) {
                        if (this.state.filters[i].id === filter) {
                            nameField = this.state.filters[i].name;
                        }
                    }

                    if (nameField == undefined && filter == "calledcards") {
                        nameField = intl.formatMessage({ id: "called.report.header" })
                    }

                    this.setState({
                        contentFilter: `${this.state.contentFilter}${nameField} = ${value}\n`
                    })
                }
                localStorage.setItem("newFilterArchivedCalleds", newFilter)
                localStorage.setItem("newSearchArchivedCalleds", newSearch)

                this.setState({ searchValue: '', filterSelected: 0 })
            }
        }
    }

    // Retorna { valid, message }. skipDateRequired=true: datas são opcionais e sem limite de 3 meses.
    validateDateRange = (skipDateRequired = false) => {
        const { dateStart, dateEnd } = this.state
        const { intl } = this.props
        try {
            const datesProvided = dateStart != null && dateEnd != null
            if (!datesProvided) {
                if (skipDateRequired) return { valid: true, message: '', datesProvided: false }
                const message = 'Informe um período para realizar a pesquisa.'
                return { valid: false, message }
            }
            const startMoment = moment(dateStart)
            const endMoment = moment(dateEnd)
            if (startMoment.isAfter(endMoment)) {
                const message = intl.formatMessage({ id: "report.audit.initial.date.higher.than.end.date" })
                return { valid: false, message }
            }
            if (!skipDateRequired) {
                const maxDateRange = startMoment.clone().add(3, 'months')
                if (endMoment.isAfter(maxDateRange)) {
                    const message = "O período máximo de busca é de 3 meses";
                    return { valid: false, message }
                }
            }
            return { valid: true, message: '', datesProvided: true }
        } catch (e) {
            return { valid: false, message: intl.formatMessage({ id: "date.pickers.invalid.date" }) }
        }
    }

    async getCalleds(page = 1, orgFieldParams = null) {

        const intl = this.props.intl
        this.emptySearchArchived = false
        this.emptySearchFinishCalleds = false
        this.emptySearchCanceledCalleds = false

        let url = `/archivedcalleds/paginate?page=${page}`

        let newFilter = localStorage.getItem('newFilterArchivedCalleds')
        let newSearch = localStorage.getItem('newSearchArchivedCalleds')

        let isSearchById = newFilter.includes('id')
        const isOrgFieldSearch = !!orgFieldParams
        const skipDateRequired = isSearchById || isOrgFieldSearch

        if (newFilter != '' && newSearch != '') {
            url += `&search=${newSearch}&field=${newFilter}`
            this.setState({ dataFilter: true })
        }

        const validateDate = this.validateDateRange(skipDateRequired)

        if (!validateDate.valid) {
            this.setState({ loading: false })
            this.setNotification("error", validateDate.message)
            return
        }

        // Adiciona datas à URL somente quando fornecidas
        if (validateDate.datesProvided) {
            const sqlDateStart = this.state.dateStart.toISOString()
            const sqlDateEnd = this.state.dateEnd.toISOString()
            url += `&dateStart=${encodeURIComponent(sqlDateStart)}&dateEnd=${encodeURIComponent(sqlDateEnd)}&dateOption=${this.state.dateOptionSelected.id}`
        }

        // Parâmetros opcionais de campos personalizados
        if (orgFieldParams) {
            url += `&orgFieldSearchAll=${orgFieldParams.mode === 'text_number'}`
            if (orgFieldParams.mode === 'text_number' && orgFieldParams.searchText)
                url += `&orgFieldSearchText=${encodeURIComponent(orgFieldParams.searchText)}`
            if (orgFieldParams.fieldId)
                url += `&orgFieldId=${orgFieldParams.fieldId}`
            if (orgFieldParams.organizationId)
                url += `&orgFieldOrganizationId=${orgFieldParams.organizationId}`
            if (orgFieldParams.optionsValuesId)
                url += `&orgFieldOptionsValuesId=${orgFieldParams.optionsValuesId}`
            if (orgFieldParams.fieldValue)
                url += `&orgFieldValue=${encodeURIComponent(orgFieldParams.fieldValue)}`
        }

        var formattedList = null

        this.setState({ selectedColumnns: [], loading: true, hasSearched: true })

        await Api.get(url)
            .then(async result => {
                if (result.data.success) {
                    if (result.data.data.length === 0) {
                        if (page > 1) {
                            this.onChangePaginate(null, (page - 1))
                        }
                        this.setState({ emptySearchArchived: false, emptySearchFinishCalleds: false, emptySearchCanceled: false, emptyArray: true });
                    }
                    else {
                        this.setState({ emptySearchArchived: false, emptySearchFinishCalleds: false, emptySearchCanceled: false, emptyArray: false });
                    }

                    let count = result.data.count

                    PapiroConsole.log(result.data.data)
                    PapiroConsole.log("result.data.data CONSOLE AQUI")
                    formattedList = result.data.data
                    let selectedCols = []
                    formattedList = result.data.data.map(item => {
                        if (item && item.calledlistdata != null) {
                            let cols = this.calledListDataFormmat(item.calledlistdata)
                            selectedCols = this.arrayUnique(selectedCols.concat(cols))
                        }

                        return {
                            ...item,
                            actions: this.isClient ? null : <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <IconButton
                                    size="small"
                                    onClick={() => this.goToCalled(item, true)}
                                >
                                    <CallMade />
                                </IconButton>

                            </div>,
                            onlyId: <LinkA component="button"
                                onClick={() => {
                                    let abl = this.context.can('Answer', 'Called');
                                    let abl2 = this.context.can('Edit', 'Called');
                                    if (abl == false && abl2 == false) {

                                        this.showMessage(true, 'error', intl.formatMessage({ id: "called.list.message.unallowed.task" }));
                                        return false;
                                    }
                                    this.goToCalled(item, false)
                                }
                                } variant="body2">
                                {item.id}
                            </LinkA>
                        }
                    })

                    var pagination = this.setPagination(count, page, 10)

                    await this.setState({
                        loading: false, count: count, calleds: formattedList, pageStart: pagination.pageStart, pageEnd: pagination.pageEnd, totalPages: pagination.totalPages, page: pagination.page
                    })
                    this.setCountLoading()
                } else {
                    this.setState({ openNotification: true, notificationVariant: 'error', })
                    Api.kickoff(result)
                    this.setCountLoading()
                }
            })
            .catch(err => {
                console.error(err)
                this.setState({
                    openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
                Api.kickoff(err)
                this.setCountLoading()
            })
            .finally(() => {
                this.setState({ loading: false })
            })
    }

    setCountLoading() {
        this.setState({ countLoading: this.state.countLoading + 1, })
        if (this.state.countLoading >= 1) {
            this.setState({
                loading: false,
            })
        }
    }

    clearFields = async () => {
        this.clearFilters()
        await this.setState({ loading: false })
    }

    clearFilters = async () => {
        localStorage.setItem('newFilterArchivedCalleds', '')
        localStorage.setItem('newSearchArchivedCalleds', '')
        localStorage.setItem('calledsPageArchivedCalleds', '1')
        await this.setState({ filterSelected: 0, searchValue: '', page: 1, contentFilter: '', contentOrder: '', loading: true })
    }

    clearDrawerFilters = async () => {
        await this.clearFilters()
        const now = new Date()
        this.setState({
            drawerFilterId: '',
            drawerFilterTitle: '',
            drawerFilterRequestUser: '',
            drawerFilterEmail: '',
            drawerFilterDocument: '',
            orgFieldSearchMode: 'text_number',
            orgFieldOrganization: null, orgField: null,
            orgFieldOptions: [], orgFieldOptionValues: [],
            orgFieldOptionValue: null, orgFieldDateValue: null,
            orgFieldCheckboxValue: null, orgFieldSearchText: '',
            orgFieldCalleds: [], orgFieldCount: 0, orgFieldActive: false,
            lastOrgFieldParams: null,
            dateStart: new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000),
            dateEnd: now,
            hasSearched: false,
            calleds: [],
            count: 0,
            totalPages: 0,
            loading: false,
        })
    }

    applyDrawerFilters = async () => {
        const { intl } = this.props
        const { drawerFilterId, drawerFilterTitle, drawerFilterRequestUser, drawerFilterEmail, drawerFilterDocument,
                orgFieldSearchMode, orgFieldOrganization, orgField, orgFieldOptionValue, orgFieldDateValue,
                orgFieldCheckboxValue, orgFieldSearchText } = this.state

        let newFilter = ''
        let newSearch = ''

        const addF = (field, value) => {
            if (value && value.trim()) {
                newFilter += field + '|'
                newSearch += value.trim() + '|'
            }
        }

        addF('id', drawerFilterId)
        addF('title', drawerFilterTitle)
        addF('requestuser', drawerFilterRequestUser)
        addF('requestusermail', drawerFilterEmail)
        addF('requestuserdocument', drawerFilterDocument)

        // monta parâmetros de campos personalizados para passar ao getCalleds
        let orgFieldParams = null
        const hasOrgFieldSearch = orgFieldSearchMode === 'text_number'
            ? orgFieldSearchText && orgFieldSearchText.trim()
            : orgField != null

        if (hasOrgFieldSearch) {
            orgFieldParams = { mode: orgFieldSearchMode, searchText: orgFieldSearchText }
            if (orgFieldSearchMode === 'specific') {
                orgFieldParams.fieldId = orgField.id
                orgFieldParams.organizationId = orgFieldOrganization?.id
                const fieldType = this.getOrgFieldType(orgField)
                if ([2, 4, 6].includes(fieldType) && orgFieldOptionValue)
                    orgFieldParams.optionsValuesId = orgFieldOptionValue.id
                else if (fieldType === 3 && orgFieldCheckboxValue != null)
                    orgFieldParams.fieldValue = orgFieldCheckboxValue
                else if (fieldType === 9 && orgFieldDateValue)
                    orgFieldParams.fieldValue = moment(orgFieldDateValue).format('YYYY-MM-DD')
            }
        }

        const hasAnyFilter = newFilter.length > 0 || !!orgFieldParams
        if (!hasAnyFilter) {
            this.setNotification("error", "Preencha ao menos um campo para realizar a pesquisa.")
            return
        }

        // Valida datas antecipadamente para filtros sensíveis a data (título/solicitante/e-mail/documento)
        const isSearchById = newFilter.includes('id')
        const isOrgField = !!orgFieldParams
        const skipDateRequired = isSearchById || isOrgField

        if (!skipDateRequired) {
            const validateDate = this.validateDateRange(false)
            if (!validateDate.valid) {
                this.setNotification("error", validateDate.message)
                return
            }
        }

        localStorage.setItem('newFilterArchivedCalleds', newFilter)
        localStorage.setItem('newSearchArchivedCalleds', newSearch)

        await this.setState({ contentOrder: '', page: 1, loading: true, hasSearched: true, calleds: [], count: 0, totalPages: 0, lastOrgFieldParams: orgFieldParams ?? null })
        await this.getCalleds(1, orgFieldParams)
    }

    callSearch = async (filter, value, type = 1) => {
        this.setState({ orgFieldCalleds: [], orgFieldCount: 0, orgFieldActive: false })
        if ((value && value.trim() != '') && filter != 0) {
            await this.addFilter(filter, value, type)
        }
        if ((this.state.contentFilter && this.state.contentFilter.length > 0) || (this.state.contentOrder && this.state.contentOrder.length > 0)) {
            await this.getCalleds(this.state.page)
        }
    }

    closeNotification = () => {
        this.setState({ openNotification: false });
    }

    handleDelete(chipToDelete) {
        const intl = this.props.intl;
        let valueAtual = this.state.contentFilter.split("\n")
        let newvalue = "";
        let newFilter = ""
        let newSearch = ""
        valueAtual.map(item => {
            if (item != "" && item != valueAtual[chipToDelete]) {
                newvalue = newvalue + item + " \n"
                let itemSplit = item.split(" = ")

                if (itemSplit && itemSplit[0] && itemSplit[1]) {
                    let nameField = itemSplit[0]
                    let filterName = this.state.filters.filter(f => f.name === itemSplit[0])

                    if (filterName && filterName.length > 0) {
                        nameField = filterName[0].id
                    }
                    else if (nameField == intl.formatMessage({ id: "called.report.header" })) {
                        nameField = "calledcards"
                    }
                    newFilter += nameField + '|'
                    newSearch += itemSplit[1] + '|'
                }
            }
        })
        this.setState({
            contentFilter: newvalue
        })
        localStorage.setItem("newFilterArchivedCalleds", newFilter)
        localStorage.setItem("newSearchArchivedCalleds", newSearch)
    }

    setPagination = (count, page, pageCount) => {
        let result = {}
        let totalPage = Math.ceil(count / pageCount)
        if (count > 0) {
            if (page == 1) {
                if (count < pageCount) {
                    result.pageStart = 1
                    result.pageEnd = count
                } else {
                    result.pageStart = 1
                    result.pageEnd = pageCount;
                }
            } else {
                let pageStart = ((page - 1) * pageCount) + 1
                result.pageStart = pageStart
                if (count >= page * pageCount) {
                    result.pageEnd = page * pageCount
                } else {
                    result.pageEnd = page * pageCount
                }
            }
            result.totalPages = totalPage
            result.page = page
            result.count = count
            result.pageCount = pageCount

        } else {
            result.totalPages = 0
            result.page = 1
            result.count = 0
            result.pageStart = 0
            result.pageEnd = 0
            result.pageCount = pageCount
        }
        return result
    }

    goToCalled = async (rowData, newTab = false) => {

        this.setState({ loading: true })
        let newassigned = rowData.assigneduser;
        this.setState({ loading: true })
        if (rowData.assigneduser) {

            if (rowData.assigneduser.email == null || (rowData.assigneduser.email && (rowData.assigneduser.email.length === 0 || rowData.assigneduser.email.length === 'undefined'))) {

                newassigned.name = `${rowData.assigneduser.name}`
            } else {

                newassigned.name = `${rowData.assigneduser.name} - ${rowData.assigneduser.email}`
            }
        }

        rowData.assigneduser = newassigned

        // COMENTADO POIS FOI RETIRADO DA API OS INCLUDES, O REDUX VEM SEM NENHUM DADO DE INCLUDE, COM AS LINHAS COMENTADAS, A PAGINA DE EDICAO BUSCA TODOS OS DADOS
        await this.props.addCurrentCalled(rowData)
        await this.props.addCalled(rowData)
        await this.props.addAccompanimentsList([])
        await this.props.addAccompanimentsListInCalled([], rowData.id)
        if (!this.isClient && rowData.status.id == 3) { // validacao de rejeicao

            this.props.history.push(`/${this.props.match.params.lang}/called-rejection-edit`)
            //this.loading(false);
        } else {
            if (newTab == false) {
                this.props.history.push(`/${this.props.match.params.lang}/called-accompaniment/${rowData.id}`)
            } else {

                let urlRedirect = "/" + this.props.match.params.lang + "/called-accompaniment/" + rowData.id
                setTimeout(() => {
                    window.open(urlRedirect, "_blank")
                    this.setState({ loading: false })
                }, 1000)
            }
        }
    }

    openCanAssignCalledDialog = (rowData, newTab = false) => {
        if (this.isTechnical && !this.isClient && !this.isCoordenator && !this.isAdmOrg && !this.admGlobal && !this.isAdm && rowData && rowData.status && rowData.status.statustypeid && rowData.status.statustypeid == 1) {
            this.setState({
                canAssignCalledDialogOpen: true,
                canAssignCalledRowData: rowData,
                canAssignCalledNewTab: newTab
            })
        } else {
            this.goToCalled(rowData, newTab)
        }
    }

    consultCalled = async (calledId) => {

        this.setState({ loading: true });
        let response = await searchById(calledId);
        if (
            response != null &&
            response.success != null &&
            response.success &&
            response.data != null &&
            response.data
        ) {
            this.setState({ loading: false });
            this.props.history.push(
                `/${this.props.match.params.lang}/called-view/${calledId}`
            );
        } else {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage:
                    response &&
                        response.response &&
                        response.response.data &&
                        response.response.data.errors &&
                        response.response.data.errors[0]
                        ? response.response.data.errors[0]
                        : intl.formatMessage({ id: "process.error" }),
            });
            Api.kickoff(response);
        }
    }

    setNotification = (variant, message) => {
        this.setState({
            openNotification: true,
            notificationVariant: variant,
            notificationMessage: message
        })
    }

    setLoading = (loading) => {
        this.setState({ loading: loading })
    }

    onChangePaginate = async (e, page) => {
        this.setState({ page: page, countLoading: 0 })
        localStorage.setItem('calledsPageArchivedCalleds', `${page}`)
        await this.getCalleds(page, this.state.lastOrgFieldParams)
    }

    handleClickExportToCSV = async () => {
        const { intl } = this.props
        const { lastOrgFieldParams } = this.state

        let newFilter = localStorage.getItem('newFilterArchivedCalleds') ?? ''
        let newSearch = localStorage.getItem('newSearchArchivedCalleds') ?? ''

        const isSearchById = newFilter.includes('id')
        const isOrgFieldSearch = !!lastOrgFieldParams
        const skipDateRequired = isSearchById || isOrgFieldSearch

        const validateDate = this.validateDateRange(skipDateRequired)
        if (!validateDate.valid) {
            this.setNotification("error", validateDate.message)
            return
        }

        this.setState({ loading: true });
        var url = '/report/archived-calleds/excel?'

        if (validateDate.datesProvided) {
            url += `dateStart=${encodeURIComponent(this.state.dateStart.toISOString())}&dateEnd=${encodeURIComponent(this.state.dateEnd.toISOString())}&dateOption=${this.state.dateOptionSelected.id}`
        }

        if (newFilter !== '' && newSearch !== '') {
            url += `&search=${newSearch}&field=${newFilter}`
        }

        if (lastOrgFieldParams) {
            url += `&orgFieldSearchAll=${lastOrgFieldParams.mode === 'text_number'}`
            if (lastOrgFieldParams.mode === 'text_number' && lastOrgFieldParams.searchText)
                url += `&orgFieldSearchText=${encodeURIComponent(lastOrgFieldParams.searchText)}`
            if (lastOrgFieldParams.fieldId)
                url += `&orgFieldId=${lastOrgFieldParams.fieldId}`
            if (lastOrgFieldParams.organizationId)
                url += `&orgFieldOrganizationId=${lastOrgFieldParams.organizationId}`
            if (lastOrgFieldParams.optionsValuesId)
                url += `&orgFieldOptionsValuesId=${lastOrgFieldParams.optionsValuesId}`
            if (lastOrgFieldParams.fieldValue)
                url += `&orgFieldValue=${encodeURIComponent(lastOrgFieldParams.fieldValue)}`
        }

        const { calleds } = this.state
        if (calleds && calleds.length > 0) {
            url += `&calledIds=${calleds.map(c => c.id).join(',')}`
        }

        await ApiReports.get(url)
            .then((response) => {
                if (response.data.success) {
                    this.setState({
                        openNotification: true,
                        notificationVariant: 'success',
                        notificationMessage: intl.formatMessage({ id: "report.sent" }) + " (" + this.props.userSession.user.email + ")",
                    });
                } else {
                    this.setState({
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: response.data.errors && response.data.errors[0] ? response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                }
            })
            .catch((error) => {
                this.setState({
                    openNotification: true,
                    notificationVariant: 'error',
                    notificationMessage: error.data && error.data.response && error.data.response.data && error.data.response.data.errors && error.data.response.data.errors[0] ? error.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
            })
            .finally(() => {
                this.setState({ loading: false })
            })
    }

    render() {
        const { classes, headerMenu, actionsHeaderMenu, intl, match, history } = this.props
        const { orgFieldSearchMode, orgFieldOrganization, orgFieldOrganizationOptions,
                orgFieldOrganizationLoading, orgField, orgFieldOptions, orgFieldOptionsLoading,
                orgFieldOptionValue, orgFieldOptionValues, orgFieldOptionValuesLoading,
                orgFieldDateValue, orgFieldCheckboxValue, orgFieldSearchText,
                openFilterDrawer, drawerAnimationClass, valueSpacingGrid,
                drawerFilterId, drawerFilterTitle, drawerFilterRequestUser, drawerFilterEmail, drawerFilterDocument } = this.state
        const TEXT_NUMBER_TYPES = [1, 5, 7, 8, 10]

        const openFilterMenu = Boolean(this.state.filterMenuAnchorEl)

        var link = `/${this.props.match.params.lang}/called-registration`
        if (this.isClient) {
            link = `/${this.props.match.params.lang}/called-registration-client`
        }

        if (Api == null) {
            var l = this.props.match.params.lang;
            document.location.href = `/${l}/unavailable`
        }

        return (

            <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
                <HeaderMenu />
                <main
                    className={clsx(classes.content, {
                        [classes.contentShift]: headerMenu.open,
                    }, classes.actionsContent, {
                        [classes.actionscontentShift]: actionsHeaderMenu.open,
                    })}
                >
                    <div className={classes.drawerHeader} />
                    <Container component='main' maxWidth={false} style={{ paddingLeft: 0, marginLeft: 0 }}>
                        <CssBaseline />

                        <Grid container spacing={6} >
                            <Grid item xs={12} sm={12}>
                                <Grid container pb={2} justifyContent="space-between">
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        size="large"
                                        className={classes.button}
                                        startIcon={<Add />}
                                        component={Link} {...{ to: link }}
                                    >
                                        {<FormattedMessage id="called.new" />}
                                    </Button>
                                    {!this.isClient &&
                                        <TreeDots items={this.state.itemsTree} />
                                    }
                                </Grid>
                                <Card className="background-title-search">
                                    <CardContent>
                                        <Grid container spacing={1} alignItems="center" direction="row">
                                            <Grid item xs>
                                                <Typography component={'span'} variant="h5">
                                                    {<FormattedMessage id="called.header" />}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs="auto">
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    size="large"
                                                    className={openFilterDrawer ? 'button-active' : ''}
                                                    startIcon={<ManageSearchIcon />}
                                                    endIcon={openFilterDrawer ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                    onClick={this.toggleFilterDrawer}
                                                >
                                                    Filtros
                                                </Button>
                                            </Grid>
                                            <Grid item xs="auto">
                                                <IconButton
                                                    color='primary'
                                                    id="filter-menu"
                                                    aria-controls={openFilterMenu ? 'filter-menu' : undefined}
                                                    aria-haspopup="true"
                                                    aria-expanded={openFilterMenu ? 'true' : undefined}
                                                    onClick={this.handleClickFilterMenu}>
                                                    <MoreVert />
                                                </IconButton>
                                                <Menu
                                                    id="filter-menu"
                                                    aria-labelledby="filter-menu"
                                                    anchorEl={this.state.filterMenuAnchorEl}
                                                    open={openFilterMenu}
                                                    onClose={this.handleCloseFilterMenu}
                                                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                                                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}>
                                                    <Tooltip title={!this.state.calleds || this.state.calleds.length === 0 ? intl.formatMessage({ id: "called.archived.export.no.data" }) : ""}>
                                                        <span>
                                                            <MenuItem
                                                                onClick={this.handleClickExportToCSV}
                                                                disabled={!this.state.calleds || this.state.calleds.length === 0}>
                                                                <ListItemIcon style={{ minWidth: 25 }}>
                                                                    <ExitToApp style={{ fontColor: "#3f51b4", fill: "#3f51b4" }} />
                                                                </ListItemIcon>
                                                                {intl.formatMessage({ id: "called.list.export" })}
                                                            </MenuItem>
                                                        </span>
                                                    </Tooltip>
                                                </Menu>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                        <Grid container spacing={0} alignItems="flex-start">
                            <Grid item xs={valueSpacingGrid}>
                                <div className='material-table'>
                                    {/*tableList()*/}
                                    <Grid container spacing={0}>
                                        {this.state.calleds.map((called) => {
                                            return <CalledCard
                                                key={called.id}
                                                archived={true}
                                                called={called}
                                                isAdm={this.isAdm}
                                                isClient={this.isClient}
                                                intl={intl}
                                                history={history}
                                                lang={match.params.lang}
                                                setNotification={this.setNotification}
                                                setLoading={this.setLoading}
                                            />
                                        })}
                                    </Grid>
                                </div>

                                {this.state.calleds.length == 0 && (
                                    <div>
                                        {this.state.hasSearched ? (
                                            <Typography variant="body2" style={{ textAlign: 'center', marginTop: 32, color: '#888' }}>
                                                {intl.formatMessage({ id: "no.results" })}
                                            </Typography>
                                        ) : (
                                            <FirstElement
                                                title={intl.formatMessage({ id: "archived.calleds" })}
                                                subtitle={intl.formatMessage({ id: "need.search" })}
                                                link={link}
                                                icon={<QueuePlayNext style={{ fontSize: "45px" }} />}
                                            />
                                        )}
                                    </div>
                                )}
                                {this.state.calleds.length > 0 &&
                                        <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                                            <Grid item xs={12} md={4}>
                                                <Pagination
                                                    count={this.state.totalPages}
                                                    page={this.state.page}
                                                    onChange={this.onChangePaginate}
                                                    showFirstButton
                                                    showLastButton />
                                            </Grid>
                                            <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                                                {this.state.pageStart} {<FormattedMessage id="to" />} {this.state.pageEnd} {<FormattedMessage id="of" />} {this.state.count} {<FormattedMessage id="register" />}
                                            </Grid>
                                        </Grid>
                                }

                            </Grid>

                            {openFilterDrawer && (() => {
                                const filteredOpts = orgFieldOptions.filter(f => !TEXT_NUMBER_TYPES.includes(this.getOrgFieldType(f)))
                                const fieldType = this.getOrgFieldType(orgField)
                                return (
                                    <Grid item xs={3} className={`filter-drawer ${drawerAnimationClass}`} style={{ maxHeight: '1350px', overflowY: 'auto', paddingTop: '10px', paddingLeft: '10px' }}>

                                                {/* ── Período ── */}
                                                <Accordion defaultExpanded disableGutters elevation={1} sx={{ mb: 1 }}>
                                                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>Período</Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails sx={{ pt: 0 }}>
                                                        <Grid xs={12} style={{ padding: '6px' }}>
                                                            <SimpleAutoComplete
                                                                label="Filtro por data*"
                                                                options={this.state.dateOptions}
                                                                stateName='dateOptionSelected'
                                                                changeSelect={this.handleChangeValue}
                                                                selected={this.state.dateOptionSelected}
                                                            />
                                                        </Grid>
                                                        <Grid xs={12} style={{ padding: '6px' }}>
                                                            <SimpleDatePicker
                                                                label={intl.formatMessage({ id: "start.date" })}
                                                                name='dateStart' stateName='dateStart'
                                                                changeDate={this.handleChangeValue}
                                                                currentDate={this.state.dateStart}
                                                                fullWidth required
                                                            />
                                                        </Grid>
                                                        <Grid xs={12} style={{ padding: '6px' }}>
                                                            <SimpleDatePicker
                                                                label={intl.formatMessage({ id: "end.date" })}
                                                                name='dateEnd' stateName='dateEnd'
                                                                changeDate={this.handleChangeValue}
                                                                currentDate={this.state.dateEnd}
                                                                fullWidth required
                                                            />
                                                        </Grid>
                                                        <Grid xs={12} style={{ padding: '6px' }}>
                                                            <Grid container spacing={1}>
                                                                <Grid item xs={6}>
                                                                    <Button variant="outlined" color="secondary" fullWidth
                                                                        sx={{ whiteSpace: 'nowrap' }}
                                                                        onClick={() => this.setState({ dateStart: null, dateEnd: null })}>
                                                                        Limpar datas
                                                                    </Button>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Tooltip
                                                                        title="Aplica automaticamente a regra padrão do sistema, definindo a data como 30 dias anteriores à data atual."
                                                                        placement="top"
                                                                        arrow
                                                                    >
                                                                        <Button variant="contained" color="primary" fullWidth
                                                                            sx={{ whiteSpace: 'nowrap' }}
                                                                            onClick={() => {
                                                                                const today = new Date()
                                                                                this.setState({
                                                                                    dateStart: new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000),
                                                                                    dateEnd: today
                                                                                })
                                                                            }}>
                                                                            Aplicar padrão
                                                                        </Button>
                                                                    </Tooltip>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>

                                                {/* ── Filtros normais ── */}
                                                <Accordion defaultExpanded disableGutters elevation={1} sx={{ mb: 1 }}>
                                                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>{intl.formatMessage({ id: "filters" })}</Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails sx={{ pt: 0 }}>
                                                        <Typography variant="caption" sx={{ px: '6px', pb: '4px', display: 'block', color: 'text.secondary' }}>
                                                            Ao preencher mais de um campo, a pesquisa retorna apenas chamados que correspondam a todos os critérios ao mesmo tempo.
                                                        </Typography>
                                                        <Grid xs={12} style={{ padding: '6px' }}>
                                                            <TextField label="ID" size="small" fullWidth
                                                                value={drawerFilterId}
                                                                onChange={e => this.setState({ drawerFilterId: e.target.value })}
                                                                onKeyDown={e => { if (e.key === 'Enter') this.applyDrawerFilters() }}
                                                            />
                                                        </Grid>
                                                        <Grid xs={12} style={{ padding: '6px' }}>
                                                            <TextField label={intl.formatMessage({ id: "title" })} size="small" fullWidth
                                                                value={drawerFilterTitle}
                                                                onChange={e => this.setState({ drawerFilterTitle: e.target.value })}
                                                                onKeyDown={e => { if (e.key === 'Enter') this.applyDrawerFilters() }}
                                                            />
                                                        </Grid>
                                                        <Grid xs={12} style={{ padding: '6px' }}>
                                                            <TextField label={intl.formatMessage({ id: "requestuser" })} size="small" fullWidth
                                                                value={drawerFilterRequestUser}
                                                                onChange={e => this.setState({ drawerFilterRequestUser: e.target.value })}
                                                                onKeyDown={e => { if (e.key === 'Enter') this.applyDrawerFilters() }}
                                                            />
                                                        </Grid>
                                                        {!this.isClient && (
                                                            <>
                                                                <Grid xs={12} style={{ padding: '6px' }}>
                                                                    <TextField label="E-mail do solicitante" size="small" fullWidth
                                                                        value={drawerFilterEmail}
                                                                        onChange={e => this.setState({ drawerFilterEmail: e.target.value })}
                                                                        onKeyDown={e => { if (e.key === 'Enter') this.applyDrawerFilters() }}
                                                                    />
                                                                </Grid>
                                                                <Grid xs={12} style={{ padding: '6px' }}>
                                                                    <TextField label={intl.formatMessage({ id: "request.user.document" })} size="small" fullWidth
                                                                        value={drawerFilterDocument}
                                                                        onChange={e => this.setState({ drawerFilterDocument: e.target.value })}
                                                                        onKeyDown={e => { if (e.key === 'Enter') this.applyDrawerFilters() }}
                                                                    />
                                                                </Grid>
                                                            </>
                                                        )}
                                                        {/* ── Campos personalizados (dentro de Filtros) ── */}
                                                        <Grid xs={12} style={{ padding: '6px', paddingTop: '12px' }}>
                                                            <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                                                                Campos personalizados
                                                            </Typography>
                                                        </Grid>
                                                        <Grid xs={12} style={{ padding: '6px' }}>
                                                            <ToggleButtonGroup
                                                                value={orgFieldSearchMode}
                                                                exclusive size="small" fullWidth
                                                                onChange={(_, v) => {
                                                                    if (!v) return
                                                                    this.setState({
                                                                        orgFieldSearchMode: v,
                                                                        orgFieldOrganization: null, orgField: null,
                                                                        orgFieldOptions: [], orgFieldOptionValues: [],
                                                                        orgFieldOptionValue: null, orgFieldDateValue: null,
                                                                        orgFieldCheckboxValue: null, orgFieldSearchText: ''
                                                                    })
                                                                }}
                                                            >
                                                                <ToggleButton value="text_number" sx={{ textTransform: 'none', fontSize: 12, flex: 1 }}>
                                                                    {intl.formatMessage({ id: "general.search.org.field.mode.text.number" })}
                                                                </ToggleButton>
                                                                <ToggleButton value="specific" sx={{ textTransform: 'none', fontSize: 12, flex: 1 }}>
                                                                    {intl.formatMessage({ id: "general.search.org.field.mode.specific" })}
                                                                </ToggleButton>
                                                            </ToggleButtonGroup>
                                                        </Grid>

                                                        {orgFieldSearchMode === 'text_number' && (
                                                            <Grid xs={12} style={{ padding: '6px' }}>
                                                                <TextField
                                                                    label={intl.formatMessage({ id: "search" })}
                                                                    size="small" fullWidth
                                                                    value={orgFieldSearchText}
                                                                    onChange={e => this.setState({ orgFieldSearchText: e.target.value })}
                                                                    onKeyDown={e => { if (e.key === 'Enter') this.applyDrawerFilters() }}
                                                                />
                                                            </Grid>
                                                        )}

                                                        {orgFieldSearchMode === 'specific' && (
                                                            <>
                                                                <Grid xs={12} style={{ padding: '6px' }}>
                                                                    <Autocomplete
                                                                        options={orgFieldOrganizationOptions}
                                                                        getOptionLabel={o => o.name || ''}
                                                                        value={orgFieldOrganization}
                                                                        onChange={this.handleOrgFieldOrganizationChange}
                                                                        loading={orgFieldOrganizationLoading}
                                                                        isOptionEqualToValue={(o, v) => o.id === v?.id}
                                                                        size="small"
                                                                        renderInput={params => (
                                                                            <TextField {...params}
                                                                                label={intl.formatMessage({ id: "general.search.org.field.organization" })}
                                                                                onFocus={this.loadOrgFieldOrganizations}
                                                                                InputProps={{ ...params.InputProps, endAdornment: <>{orgFieldOrganizationLoading && <CircularProgress size={16} />}{params.InputProps.endAdornment}</> }}
                                                                            />
                                                                        )}
                                                                    />
                                                                </Grid>
                                                                <Grid xs={12} style={{ padding: '6px' }}>
                                                                    <Autocomplete
                                                                        options={filteredOpts}
                                                                        getOptionLabel={f => f.name || ''}
                                                                        value={orgField}
                                                                        onChange={this.handleOrgFieldFieldChange}
                                                                        loading={orgFieldOptionsLoading}
                                                                        disabled={!orgFieldOrganization}
                                                                        isOptionEqualToValue={(o, v) => o.id === v?.id}
                                                                        size="small"
                                                                        renderInput={params => (
                                                                            <TextField {...params}
                                                                                label={intl.formatMessage({ id: "general.search.org.field.field" })}
                                                                                InputProps={{ ...params.InputProps, endAdornment: <>{orgFieldOptionsLoading && <CircularProgress size={16} />}{params.InputProps.endAdornment}</> }}
                                                                            />
                                                                        )}
                                                                    />
                                                                </Grid>
                                                                {orgField && [2, 4, 6].includes(fieldType) && (
                                                                    <Grid xs={12} style={{ padding: '6px' }}>
                                                                        <Autocomplete
                                                                            options={orgFieldOptionValues}
                                                                            getOptionLabel={o => o.name || o.value || ''}
                                                                            value={orgFieldOptionValue}
                                                                            onChange={(_, v) => this.setState({ orgFieldOptionValue: v })}
                                                                            loading={orgFieldOptionValuesLoading}
                                                                            isOptionEqualToValue={(o, v) => o.id === v?.id}
                                                                            size="small"
                                                                            renderInput={params => (
                                                                                <TextField {...params}
                                                                                    label={intl.formatMessage({ id: "general.search.org.field.option.value" })}
                                                                                    InputProps={{ ...params.InputProps, endAdornment: <>{orgFieldOptionValuesLoading && <CircularProgress size={16} />}{params.InputProps.endAdornment}</> }}
                                                                                />
                                                                            )}
                                                                        />
                                                                    </Grid>
                                                                )}
                                                                {orgField && fieldType === 3 && (
                                                                    <Grid xs={12} style={{ padding: '6px' }}>
                                                                        <FormControl size="small" fullWidth>
                                                                            <FormLabel sx={{ fontSize: 13 }}>{orgField.name}</FormLabel>
                                                                            <RadioGroup row value={orgFieldCheckboxValue} onChange={e => this.setState({ orgFieldCheckboxValue: e.target.value })}>
                                                                                <FormControlLabel value="true" control={<Radio size="small" />} label={intl.formatMessage({ id: "general.search.org.field.checkbox.yes" })} />
                                                                                <FormControlLabel value="false" control={<Radio size="small" />} label={intl.formatMessage({ id: "general.search.org.field.checkbox.no" })} />
                                                                            </RadioGroup>
                                                                        </FormControl>
                                                                    </Grid>
                                                                )}
                                                                {orgField && fieldType === 9 && (
                                                                    <Grid xs={12} style={{ padding: '6px' }}>
                                                                        <SimpleDatePicker
                                                                            label={intl.formatMessage({ id: "general.search.org.field.date.value" })}
                                                                            name="orgFieldDateArchived" stateName="orgFieldDateArchived"
                                                                            changeDate={(_, v) => this.setState({ orgFieldDateValue: v })}
                                                                            currentDate={orgFieldDateValue}
                                                                            fullWidth
                                                                        />
                                                                    </Grid>
                                                                )}
                                                            </>
                                                        )}

                                                        {/* ── Botões únicos Aplicar / Limpar ── */}
                                                        <Grid xs={12} style={{ padding: '6px' }}>
                                                            <Grid container spacing={1}>
                                                                <Grid item xs={6}>
                                                                    <Button variant="outlined" color="secondary" fullWidth
                                                                        onClick={this.clearDrawerFilters}
                                                                        disabled={this.state.loading}>
                                                                        Limpar
                                                                    </Button>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Tooltip
                                                                        title="As datas do período serão aplicadas à pesquisa. Ao pesquisar por ID ou campo personalizado, a pesquisa pode ser realizada sem informar um período."
                                                                        placement="top"
                                                                        arrow
                                                                    >
                                                                        <span style={{ display: 'block' }}>
                                                                            <Button variant="contained" color="primary" fullWidth
                                                                                onClick={this.applyDrawerFilters}
                                                                                disabled={this.state.loading}>
                                                                                Aplicar
                                                                            </Button>
                                                                        </span>
                                                                    </Tooltip>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>

                                    </Grid>
                                )
                            })()}
                        </Grid>

                        {this.state.loading && (
                            <Overlay>
                                <CircularProgress color="secondary" />
                            </Overlay>
                        )}

                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />
                    </Container>
                </main>
                <Footer organizations={this.userOrganizations} />
            </div>
        )
    }
}

CalledsArchived.propTypes = {
    classes: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
    lastCalledsQueue: state.lastCalledsQueue,
    actionsHeaderMenu: state.actionsHeaderMenu,
    headerMenu: state.headerMenu,
    userSession: state.userSession
})

const mapDispatchToProps = dispatch =>
    bindActionCreators(Object.assign({}, calledsActions, headerMenuActions, lastCalledsQueueActions, userSessionActions), dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(CalledsArchived)))
CalledsArchived.contextType = AbilityContext
